import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import GraphicDesigning2 from '../../../img/Course-Elements/GraphicDesigning2.png'
import CourseOperate from '../../Shared/Courses/CourseOperate';

const GraphicsDesigning = () => {


    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-5xl font-semibold my-4'>Graphic <span className='text-orange-400'>Designing</span></h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1199</h1>
            <h2 className=''>Design stunning graphics using Adobe Photoshop</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off by applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why Learn Graphic Designing?</h1>
                    <h1 className='text-2xl my-2'>Freedom</h1>
                    <p>This is one sector that gives you both financial independence and creative
                        freedom, the latter of which allows you to create the world as you see fit.</p>
                    <h1 className='text-2xl my-2'>Fun</h1>
                    <h3>Modern design teams and studios are among of the most active and
                        fascinating places to work since each day brings a new problem that must be overcome.
                    </h3>
                    <h1 className='text-2xl my-2'>Impact</h1>
                    <p>Your efforts have a genuine and noticeable influence, whether it be
                        on a social media poster for an NGO or a print advertisement for a company!</p>
                </div>
                <img className='flex-1' src={GraphicDesigning2} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};
export default GraphicsDesigning;